var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:_vm.btnClass},[(_vm.isLoading)?_c('v-icon',{staticClass:"loading",attrs:{"name":"spinner","pulse":""}}):_vm._e(),_vm._v(" "),_c('span',{class:_vm.showLoading},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.btnLabel)+"\n  ")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06518fa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActionButton.vue
// module id = null
// module chunks = 